import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import axios from "axios";
import { toast } from "react-toastify";
import Switch from "react-switch";
import xlsx from "xlsx";

import Dropzone from "../DropZone";
import GlobalContext from "../../../Hooks/globalContext";
import DefaultButton from "../../Common/DefaultButton";
import { HOST, NUMBER_REGEX } from "../../../Utils/constants";
import useState from "../../../Hooks/useState";
import Input from "../../Common/Input";
import useInput from "../../../Hooks/useInput";
import Loader from "../../Common/Loader";
import Theme from "../../../Styles/Theme";

const Top = styled.div`
  padding: 10px;
  height: calc(100% - 60px);
  width: 100%;
  overflow: auto;
`;

const Bottom = styled.div`
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px;
`;

const BottomItem = styled.div``;

const InnerBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  :first-child {
    margin-bottom: 25px;
  }
`;

const InnerTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const InnerContent = styled.div`
  padding: 10px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 700px;
`;

const InputWrapper = styled.div`
  max-width: 320px;
  width: 100%;
`;

const Page = ({ adminPage, focus }) => {
  const { httpHeader, modal, language, web3 } = useContext(GlobalContext);
  const singleFile = useState(null);
  const xlsxTable = useState(null);
  const isLoading = useState(false);

  const lockOnClick = async () => {
    isLoading.setState(true);
    const { data } = await axios.post(`${HOST}/admin/lock/xlsx`, xlsxTable.state, httpHeader());

    if (data.status) {
      modal.setState("성공적으로 락업되었습니다.");
      singleFile.setState(null);
      xlsxTable.setState(null);
    } else {
      modal.setState("서버 오류입니다. 잠시 후에 다시 시도해주세요.");
    }
    isLoading.setState(false);
  };

  const blobToXlsx = () => {
    const workbook = xlsx.read(singleFile.state.binary, { type: "binary" }).Sheets;
    const content = workbook["Sheet1"];
    const result = [];
    for (let key in content) {
      const tag = key.substring(0, 1);

      const num = Number(key.substring(1, key.length));
      if (num > 1) {
        switch (tag) {
          case "B":
            result[num] = {
              ...result[num],
              address: content[key].v,
            };
            break;
          case "C":
            result[num] = {
              ...result[num],
              amount: content[key].v,
            };
            break;
          case "D":
            result[num] = {
              ...result[num],
              day: Number(content[key].v),
            };
            break;
          case "E":
            result[num] = {
              ...result[num],
              unit: Number(content[key].v),
            };
            break;
          case "F":
            result[num] = {
              ...result[num],
              type: content[key].v,
            };
            break;
        }
      }
    }

    const errorFlag = result.some((item) => {
      if (!web3.utils.isAddress(item.address)) {
        return true;
      }

      if (isNaN(Number(item.amount)) || isNaN(Number(item.day)) || isNaN(Number(item.unit))) {
        return true;
      }

      if (item.unit > item.day) {
        return true;
      }

      if (item.day % item.unit !== 0) {
        return true;
      }

      if (item.type.toLowerCase() !== "lcms" && item.type.toLowerCase() !== "esg") {
        return true;
      }
    });

    if (errorFlag) {
      modal.setState(
        "잘못된 정보가 있습니다. 지갑주소가 잘못되었거나 락업일, 해제 단위의 식이 맞지 않습니다. 혹은 토큰 타입이 lcms/esg가 아닙니다."
      );
    } else {
      xlsxTable.setState(result);
    }
  };

  const preload = () => {};

  useEffect(preload, []);

  return true ? (
    <>
      <Top>
        <InnerTitle>{"파일 업로드"}</InnerTitle>
        <InnerBox>
          <Dropzone singleFile={singleFile} />
          {singleFile.state && (
            <DefaultButton style={{ marginTop: 10, maxWidth: 1140 }} text="엑셀 파일 변환" block onClick={blobToXlsx} />
          )}
          {xlsxTable.state && (
            <DefaultButton
              disabled={isLoading.state}
              style={{
                marginTop: 10,
                maxWidth: 1140,
                border: `1px solid ${Theme.mainColor}`,
                color: Theme.mainColor,
                backgroundColor: "white",
              }}
              loaderColor={Theme.mainColor}
              text="락업 요청"
              block
              onClick={lockOnClick}
            />
          )}
        </InnerBox>
      </Top>
      <Bottom>
        <BottomItem></BottomItem>
        <BottomItem></BottomItem>
        <BottomItem>
          {/* <DefaultButton style={{ padding: "10px 15px" }} text={"변경"} onClick={updateOnClick} /> */}
        </BottomItem>
      </Bottom>
    </>
  ) : (
    <Loader />
  );
};

export default Page;
